










import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

import CompatibleBrowser from '@/components/compatible-browser/compatible-browser.vue';
import LoginPopup from '@/components/login-popup/login-popup.vue';
import Toast from '@/components/toast/toast.vue';

import {i18nService, notificationService} from '@/services';
import {Socket} from '@/webSocket';

import {AUTH_GET_USERNAME, AUTH_LOGIN, AUTH_IS_LOGGED, UPDATE_FLAG_MAKING_LOGIN} from '@/store/modules/authentication/types';
import {payloadLogin} from '@/store/modules/authentication/actions';
import axios from 'axios';
import {CONFIG} from '@/config';
import {UserSessionStorageService} from '@/services/user-session-storage.service';
import NavBar from '@/components/navbar/navbar.vue';
import AuthService from '@/services/auth.service';

const auth = new AuthService();

@Component({
    components: {
        NavBar,
        CompatibleBrowser,
        LoginPopup,
        Toast
    }
})
export default class App extends Vue {
    @Getter(AUTH_GET_USERNAME)
    public userName: string;

    @Getter(AUTH_IS_LOGGED)
    public isLogged: boolean;

    private webSocket: Socket;

    @Action(AUTH_LOGIN)
    public authLogin: (userInfo: payloadLogin) => void;

    @Action(UPDATE_FLAG_MAKING_LOGIN)
    public updateFlagMakingLogin: (isMakingLogin: boolean) => void;

    subscribeQueue() {
        this.webSocket = new Socket(`usr_${this.userName}`, (msg: any) => {
            if (msg.status && msg.idfile) {
                notificationService.sendAlert({
                    status: msg.status,
                    data: {...msg, id: msg.idfile, referenceDate: new Date(msg.referencedate)}
                });
                return;
            }
        });
    }

    created() {
        this.setLanguage();
        this.loginUsingNeogigToken();
    }

    setLanguage() {
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(String(prop)),
        });

        if (params['language']) {
          localStorage.setItem('language', params['language']);
        }
    }

    mounted() {
        i18nService.i18nSetup(() => {
            if (i18nService.getCurrentLanguage().indexOf('pt') > -1) {
                require('@progress/kendo-ui/js/messages/kendo.messages.pt-PT');
                require('@progress/kendo-ui/js/cultures/kendo.culture.pt-BR');
                kendo.culture('pt-BR');
            } else {
                require('@progress/kendo-ui/js/messages/kendo.messages.en-US');
                require('@progress/kendo-ui/js/cultures/kendo.culture.en-US');
                kendo.culture('en-US');
            }

            this.subscribeQueue();
        });

        this.addIntercomMessage();
    }

  private async addIntercomMessage(): Promise<void> {
      if(await auth.isAuthenticated()) {
        const authUser = await auth.getUser();
        (window as any).intercomSettings = {
          api_base: 'https://api-iam.intercom.io',
          app_id: 'p51ayt5q',
          name: authUser.profile.name,
          email: authUser.profile.email,
          created_at: authUser.profile.auth_time,
          phone: authUser.profile.phone_number,
          user_hash: authUser.profile.intercom_hmac,
          alignment: 'right',
        };

        // @ts-ignore
        (function(){var w=window as any;var ic=w.Intercom;if(typeof ic==='function'){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/p51ayt5q';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
      }
    }

  private loginUsingNeogigToken(): void {

       this.updateFlagMakingLogin(true);
       auth.isAuthenticated()
           .then(isAuthenticated => {
             if (isAuthenticated) {
               const {token, username} = UserSessionStorageService.user;
               this.authLogin({
                 username: username,
                 email: username,
                 token
                });
              }
              else {
                auth.login();
              }
       });
    }
}
